<!--
 * @Description: 拖动接纳组件
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-06-01 15:37:16
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-08 11:49:17
-->
<template>
    <draggable
        v-model='dataList'
        class="c-settingField-dragWrapper"
        :group='dragConfig'
        @change="handleAddItem"
        @choose='handleItemChoose($event,true)'
        @unchoose='handleItemChoose($event,false)'
    >
        <div  
            class="c-settingField-dragWrapper-items color333 br2"
            v-for='(i,index) in dataList' 
            @click.stop = "()=>{}"
            :key='index' 
            :customType = 'i.customTypes'
        >
            <div class="c-settingField-dragWrapper-items-wrapper">
                <img 
                    :src="'/static/icon/'+(i.customTypes==='1'?'text_s.png':i.customTypes==='2'?'date_s.png':i.customTypes==='3'?'number_s.png':'select_s.png')"
                    alt="" 
                    class="c-settingField-dragWrapper-items-icon"
                >
                <span class="c-settingField-dragWrapper-items-label textOver" :title="i.name">{{i.name}}</span>
                <div>
                    <!-- 列&&行显示内容 -->
                    <el-select 
                        v-model="i.value"  
                        size='mini' 
                        v-if='i.customType==="2"&&isSettingFieldShow&&id!=="valueList"' 
                        placeholder=""
                        class='c-settingField-dragWrapper-items-select'
                        @change='handleSelectChange'
                    >
                        <el-option
                            v-for="item in dateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- 值显示内容 -->
                     <el-select 
                        v-model="i.value"  
                        size='mini' 
                        v-if='i.customType==="3"&&id==="valueList"&&isSettingFieldShow' 
                        placeholder=""
                        class='c-settingField-dragWrapper-items-select'
                        @change='handleSelectChange'
                        >
                        <el-option
                            v-for="item in numberList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span v-if="id==='valueList'&&i.customType!=='3'" class='c-settingField-dragWrapper-items-countText'>计数</span>
                </div>	
            </div>
            <img 
                src="/static/icon/acc-delete-item.png" 
                alt="删除" 
                class="c-settingField-dragWrapper-items-delete" 
                title="删除"
                @mouseenter = "deleteHover(i,true)"
                @mouseleave = "deleteHover(i,false)"
                @click = "delItem(i,index)"
            >
            <div class="c-settingField-dragWrapper-items-deleteLine" v-show = "i.isShowLine"></div>			
        </div>
    </draggable> 
</template>
<script>
import config from "./dragConfig.js"
import draggable from "vuedraggable"
export default {
    components: {
        draggable
    },
    props:{
        id:String,
        isSettingFieldShow:Boolean,
        dateList:Array,
        numberList:Array,
    },
    data() {
        return {
            dragConfig:{},  // 拖动配置
            dataList:[],  
        }
    },
    created() {
        this.dragConfig = config.getDragConfig("2")
    },
    methods: {
        /**
         * @description: 
         * @param {*} e  鼠标按住&&松开 对象
         * @param {*} type  true 按住  false 松开
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleItemChoose(e,type) {
            let itemName = "";
            if(this.id === "valueList") {
                itemName = e.item.innerText?(e.item.innerText.split(/[\n,]/g))[0]:"";
            }else {
                itemName = e.item.innerText.trim();
            }
            let params = {
                customtype: e.item.attributes.customtype.value.trim(),
                itemName: itemName,
                isHold: type,
                id: this.id
            }
            this.$emit("itemHold",params)
        },
        /**
         * @description: 删除项
         * @param {Object} item 当前hover项
         * @param {Number} index 删除的索引
         * @return {*}
         * @author: jinchuan.lee
         */        
        delItem(item,index) {
            item.isShowLine = false;
            this.dataList.splice(index,1);
            let params = {
                id: this.id,
                list: this.dataList
            }
           this.$emit('change',params)
        },
        /**
         * @description: 
         * @param {Object} item 当前hover项
         * @param {Boolean} type 
         * @return {*}
         * @author: jinchuan.lee
         */        
        deleteHover(item,type) {
            item.isShowLine = type;
        },
        /**
         * @description: 添加选项方法
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleAddItem(e) {
            let data = this.dataList;
            if(e.added && data.length > 0) {
                let addItem = e.added.element;
                data.splice(e.added.newIndex , 1 , {...addItem})
            }
            let params = {
                id: this.id,
                list: data
            }
           this.$emit('change',params)
        },
        /**
         * @description: 
         * @param {*} e 当前选择值
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleSelectChange(e) {
            this.$emit('selectChange',e)
        },
        
    }
}
</script>
<style lang="less" scoped>
.c-settingField-dragWrapper {
    height: 100%;
    &-items {
        padding: 0.07rem .1rem;
        background: #F1F8FF;
        width: 1.7rem;
        box-sizing: border-box;
        margin-bottom: .1rem;
        cursor: pointer;
        padding-right: 0;
        position: relative;
        &-wrapper {
            display: flex;
            align-items: center;
        }
        &-countText {
            margin-right: .1rem;
            font-size: .12rem;
        }
        &-deleteLine {
            position: absolute;
            background: red;
            height: 1px;
            width: 100%;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
        &-label {
            flex: 1;
            display: inline-block;
        }
        &-delete {
            width: .16rem;
            height: .16rem;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: -.21rem;
            transition: all .1s;
        }
        &-select {
            width: 60px;
            /deep/ .el-input__inner {
                border:none;
                outline: none;
                box-shadow: none;
                background-color: #F1F8FF;
                height: 18px;
                font-size:12px;
                color: #333;
                padding-left: 0;
                font-size: .12rem;
                padding-right: 20px;
            }
            /deep/ .el-input__icon {
                line-height: 18px;
                font-size: .12rem;
            }
        }
        &-icon {
            width: .16rem;
            height: .16rem;
            margin-right: .1rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/cashier/components/crossAnalysis/dragList.vue